import * as React from 'react';
import Axios from 'axios';
import { Col, Row } from 'react-bootstrap';
import ReactMarkdown = require('react-markdown');
import './style.scss';

class CookiePolicyContainer extends React.Component {
  public state = {
    content: '',
  };

  public componentWillMount() {
    Axios.get('public/contents?filter[slug]=cookies')
      .then((response) => {
        let contentString = response.data.data[0].attributes.sections.body;
        if (!contentString) {
          contentString = 'An issue occurred fetching Cookie Policy.';
        }

        this.setState({ content: contentString});
      })
      .catch((error) => {
        this.setState({ content: 'An issue occurred fetching Cookie Policy.' });
      });
  }

  public render() {
    return (
      <div className="internal-page">
        <div className="container">
          <Row>
            <Col xs={12} className="column">
              <div className="customer-area-container">
                <Row className="page-container animated fadeIn">
                  <div className="cookie-policy-container">
                    <ReactMarkdown
                      source={this.state.content}
                      escapeHtml={false}
                    />
                  </div>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default (CookiePolicyContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Brochure/scenes/CookiePolicyContainer/index.tsx